import React from 'react'
import ContactUsPage from '../components/ContactUs/ContactUsPage'

export default function Gallery(props) {

    const setTitle = props.setTitle;
    const setProgress = props.setProgress;

    React.useEffect(() => {
        setTitle("Contact Us - Academic Outreach and New Initiatives | IIT Delhi")
        setProgress(100);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <ContactUsPage />
        </>
    )
}
